import React from "react";
import { Layers } from "lucide-react";
import CarSchematic from "@/components/CarSchematic";
import PanelRow from "./PanelRow";
import CustomPanelForm from "./CustomPanelForm";
import { Section, SectionTitle } from "./Section";
import { formatMoney, panelUnitPrice } from "@/lib/pricing";

export default function PanelsSection({ settings, sym, size, builder, collapsed = false }) {
  const { selections, customPanels, getSel, updateSel, toggleSelect, addCustomPanel, removeCustomPanel } = builder;
  if (collapsed) {
    return (
      <Section>
        <SectionTitle n="2" en="Panels & Repair" zh="面板与修整" icon={Layers} />
        <p className="text-sm text-slate-400 mt-3" data-testid="panels-collapsed-note">Full car respray selected (Section 6) — every panel is included, so per-panel picks are off. Switch Section 6 to <span className="text-amber-300 font-semibold">Off</span> to quote individual panels again.</p>
      </Section>
    );
  }
  return (
    <Section>
      <SectionTitle n="2" en="Panels & Repair" zh="面板与修整" icon={Layers} />
      <div className="grid grid-cols-[minmax(0,1fr)] md:grid-cols-[240px_minmax(0,1fr)] gap-6 mt-4">
        <div className="bg-slate-950/40 rounded-xl border border-slate-800 p-4">
          <CarSchematic selections={selections} onToggle={toggleSelect} />
          <p className="text-center text-[10px] text-slate-500 mt-2 uppercase tracking-wider">Tap panels to select · 点击选择</p>
        </div>
        <div className="space-y-2">
          {[...settings.panels, ...customPanels].map((p) => (
            <PanelRow key={p.key} panel={p} sel={getSel(p.key)} settings={settings} sym={sym}
              onToggle={() => toggleSelect(p.key)}
              onSprayMode={(m, price) => updateSel(p.key, { sprayMode: m, touchupPrice: price ?? null })}
              onTouchupPrice={(price) => updateSel(p.key, { touchupPrice: price })}
              onRepair={(r, price) => updateSel(p.key, { repair: r, repairPrice: price ?? null })}
              onRepairPrice={(price) => updateSel(p.key, { repairPrice: price })}
              onSpecial={(v) => updateSel(p.key, { special: v })}
              onQty={p.per_unit ? (q) => updateSel(p.key, { qty: q }) : null}
              onRemove={p.custom ? () => removeCustomPanel(p.key) : null}
              priceEach={formatMoney(sym, panelUnitPrice(settings, p, size))}
            />
          ))}
          <CustomPanelForm onAdd={addCustomPanel} />
        </div>
      </div>
    </Section>
  );
}
